import { Link } from "react-router-dom";
import { supportWidgetPaths } from "@circle-react/helpers/urlHelpers";
import { Typography } from "@circle-react-uikit/Typography";
import { Button } from "./Button";

interface NeedHelpWidgetProps {
  buttonText: string;
  helpText: string;
}

export const NeedHelpWidget = ({
  helpText,
  buttonText,
}: NeedHelpWidgetProps) => (
  <div className="flex flex-col justify-center py-2">
    <div className="mx-auto mb-5 mt-auto w-full">
      <div className="border-primary bg-primary rounded-lg border">
        <div className="mt-4 text-center">
          <Typography.LabelMd weight="semibold" color="dark:text-[#ABAFB2]">
            {helpText}
          </Typography.LabelMd>
        </div>
        <div className="mx-6 my-5">
          <Link to={supportWidgetPaths.askChatBot()}>
            <Button
              label={buttonText}
              className="dark:text-primary rounded-3xl bg-[#2B2E33]"
            />
          </Link>
        </div>
      </div>
    </div>
  </div>
);
